/* BrightWhite 2.0 — zachowania sklepu (vanilla JS) */
(function () {
  'use strict';
  var R = (window.BW && window.BW.routes) || {};
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };
  var money = function (c) { c = Math.round(c); var g = c % 100; return Math.floor(c / 100) + ',' + (g < 10 ? '0' : '') + g + ' zł'; };
  window.BWMoney = money;
  var SPIN = '<svg class="x-spin" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M21 12a9 9 0 1 1-6.219-8.56"/></svg>';

  /* ---------- Menu mobilne ---------- */
  function initHeader() {
    var t = $('[data-x-burger]'), nav = $('[data-x-mnav]');
    if (t && nav) t.addEventListener('click', function () {
      var open = nav.hidden; nav.hidden = !open; t.setAttribute('aria-expanded', String(open));
    });
  }

  /* ---------- Wyszukiwarka ---------- */
  function initSearch() {
    var m = $('[data-x-search]'); if (!m) return;
    var input = $('input', m), list = $('[data-x-search-res]', m), data = [];
    try { data = JSON.parse($('[data-x-search-data]').textContent); } catch (e) {}
    function render() {
      var q = input.value.trim().toLowerCase();
      var res = q ? data.filter(function (p) { return p.t.toLowerCase().indexOf(q) > -1; }).slice(0, 6) : data.slice(0, 5);
      list.innerHTML = res.length ? res.map(function (p) {
        return '<a href="' + esc(p.u) + '"><img src="' + esc(p.i) + '" alt="" loading="lazy"><div><b style="display:block;font:800 14.5px/1.3 var(--font-display);color:var(--ink)">' + esc(p.n) + '</b><span style="font-size:13px;color:var(--muted)">' + esc(p.p) + '</span></div></a>';
      }).join('') : '<p style="padding:24px 18px;color:var(--muted)">Brak wyników. <a class="x-link" href="' + (R.all || '/collections/all') + '">Zobacz wszystkie produkty</a></p>';
    }
    function open() { m.hidden = false; render(); setTimeout(function () { input.focus(); }, 20); document.documentElement.style.overflow = 'hidden'; }
    function close() { m.hidden = true; document.documentElement.style.overflow = ''; }
    input.addEventListener('input', render);
    $$('[data-x-search-open]').forEach(function (b) { b.addEventListener('click', open); });
    m.addEventListener('click', function (e) { if (e.target === m || e.target.closest('[data-x-search-close]')) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !m.hidden) close(); });
  }

  /* ---------- Koszyk ---------- */
  function shipState() { var d = $('[data-x-drawer]'); return d ? { pct: +(d.dataset.pct || 0), free: d.dataset.free === 'true' } : { pct: 0, free: false }; }
  function animateShip(from) {
    var el = $('[data-x-ship]'); if (!el) return;
    $$('.x-ship2__fill, .x-ship2__truck', el).forEach(function (x) { x.style.setProperty('--from', from + '%'); });
    el.classList.remove('is-go'); void el.offsetWidth;
    requestAnimationFrame(function () { requestAnimationFrame(function () { el.classList.add('is-go'); }); });
  }
  function confetti() {
    var box = $('.x-confetti'); if (!box || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var colors = ['#1F4FE0', '#0FA97B', '#F5B301', '#5B5BF7', '#E11D48', '#7FB2FF'], html = '';
    for (var i = 0; i < 70; i++) {
      html += '<i style="left:' + (55 + Math.random() * 45) + '%;background:' + colors[i % colors.length] + ';--dx:' + (Math.random() * 240 - 120) + 'px;--r:' + (Math.random() * 720) + 'deg;animation-delay:' + (Math.random() * .35) + 's"></i>';
    }
    box.innerHTML = html; setTimeout(function () { box.innerHTML = ''; }, 2400);
  }
  var lastAdded = null;
  var Cart = {
    el: function () { return $('[data-x-drawer]'); },
    open: function () {
      var d = this.el(); if (!d) { location.href = R.cart; return; }
      var wasOpen = d.classList.contains('is-open');
      d.classList.add('is-open'); d.setAttribute('aria-hidden', 'false');
      document.documentElement.style.overflow = 'hidden';
      var p = $('[role=dialog]', d); if (p) p.focus();
      if (!wasOpen) animateShip(0);
    },
    close: function () {
      var d = this.el(); if (!d) return;
      d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = '';
    },
    apply: function (html) {
      if (!html) return;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = $('[data-x-drawer]', doc), cur = this.el();
      if (fresh && cur) { var o = cur.classList.contains('is-open'); cur.innerHTML = fresh.innerHTML; cur.dataset.free = fresh.dataset.free; cur.dataset.pct = fresh.dataset.pct; if (o) cur.classList.add('is-open'); }
    },
    refresh: function (sections) {
      var self = this;
      var p = sections && sections['cart-drawer'] ? Promise.resolve(self.apply(sections['cart-drawer']))
        : fetch(R.root + '?sections=cart-drawer').then(function (r) { return r.json(); }).then(function (j) { self.apply(j['cart-drawer']); });
      return p.then(function () { return fetch(R.cart + '.js'); }).then(function (r) { return r.json(); }).then(function (c) {
        $$('[data-x-count]').forEach(function (el) { el.textContent = c.item_count; el.hidden = c.item_count === 0; });
        return c;
      });
    },
    post: function (url, body) {
      body.sections = 'cart-drawer'; body.sections_url = location.pathname;
      return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Nie udało się dodać do koszyka'); return j; }); });
    },
    add: function (items, opts) {
      var self = this; opts = opts || {};
      var before = shipState(), wasOpen = this.el() && this.el().classList.contains('is-open');
      lastAdded = items[0] && items[0].id;
      return this.post(R.cartAdd + '.js', { items: items }).then(function (j) { return self.refresh(j.sections); })
        .then(function (c) {
          if (opts.open !== false) {
            var d = self.el(); if (d && !wasOpen) { d.classList.add('is-open'); d.setAttribute('aria-hidden', 'false'); document.documentElement.style.overflow = 'hidden'; }
            animateShip(before.pct);
            var after = shipState(); if (!before.free && after.free) setTimeout(confetti, 500);
            var line = lastAdded && $('.x-line[data-vid="' + lastAdded + '"]'); if (line) { line.classList.add('is-new'); line.scrollIntoView({ block: 'nearest' }); }
          }
          $$('[data-x-count]').forEach(function (el) { el.classList.remove('is-bump'); void el.offsetWidth; el.classList.add('is-bump'); });
          return c;
        })
        .catch(function (e) { alert(e.message); throw e; });
    },
    change: function (line, qty) {
      var self = this, before = shipState();
      return this.post(R.cartChange + '.js', { line: line, quantity: qty }).then(function (j) { return self.refresh(j.sections); })
        .then(function () { animateShip(before.pct); var after = shipState(); if (!before.free && after.free) setTimeout(confetti, 400); })
        .catch(function (e) { alert(e.message); });
    }
  };
  window.BWCart = Cart;
  function loading(btn, on) {
    if (!btn) return;
    if (on) { btn.dataset.label = btn.innerHTML; btn.disabled = true; btn.innerHTML = SPIN; }
    else { btn.disabled = false; if (btn.dataset.label) btn.innerHTML = btn.dataset.label; }
  }
  window.BWLoading = loading;

  function initCart() {
    document.addEventListener('click', function (e) {
      var t;
      if ((t = e.target.closest('[data-x-cart-open]')) && Cart.el()) { e.preventDefault(); Cart.open(); return; }
      if (e.target.closest('[data-x-cart-close]')) { Cart.close(); return; }
      if ((t = e.target.closest('[data-x-qty]'))) {
        e.preventDefault(); t.disabled = true;
        Cart.change(+t.getAttribute('data-x-qty'), +t.getAttribute('data-qty')); return;
      }
      if ((t = e.target.closest('[data-x-add]'))) {
        e.preventDefault(); loading(t, true);
        Cart.add([{ id: +t.getAttribute('data-x-add'), quantity: +(t.getAttribute('data-quantity') || 1) }])
          .finally(function () { loading(t, false); });
      }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') Cart.close(); });
    document.addEventListener('submit', function (e) {
      var f = e.target.closest('form[data-x-product-form]'); if (!f) return;
      e.preventDefault();
      var fd = new FormData(f), btn = e.submitter || $('[type=submit]', f), now = btn && btn.hasAttribute('data-x-now');
      loading(btn, true);
      Cart.add([{ id: +fd.get('id'), quantity: +(fd.get('quantity') || 1) }], { open: !now })
        .then(function () { if (now) location.href = '/checkout'; })
        .finally(function () { loading(btn, false); });
    });
  }

  /* ---------- Akordeony (FAQ, produkt) ---------- */
  function initAcc() {
    document.addEventListener('click', function (e) {
      var b = e.target.closest('[data-x-acc]'); if (!b) return;
      var item = b.parentElement, open = item.getAttribute('data-state') !== 'open';
      var group = item.closest('[data-x-acc-single]');
      if (group && open) $$('[data-state=open]', group).forEach(function (o) { if (o !== item) toggle(o, false); });
      toggle(item, open);
    });
    function toggle(item, open) {
      item.setAttribute('data-state', open ? 'open' : 'closed');
      var b = $('[data-x-acc]', item), p = b && b.nextElementSibling;
      if (b) b.setAttribute('aria-expanded', String(open));
      if (p) p.hidden = !open;
    }
  }

  /* ---------- Przed / po ---------- */
  function initBA() {
    $$('[data-x-ba]').forEach(function (f) {
      var drag = false, knob = $('[data-x-ba-knob]', f), pos = 50;
      function set(v) { pos = Math.max(0, Math.min(100, v)); f.style.setProperty('--pos', pos + '%'); if (knob) knob.setAttribute('aria-valuenow', Math.round(pos)); }
      function mv(x) { var r = f.getBoundingClientRect(); set((x - r.left) / r.width * 100); }
      f.addEventListener('pointerdown', function (e) { drag = true; f.setPointerCapture && f.setPointerCapture(e.pointerId); mv(e.clientX); });
      f.addEventListener('pointermove', function (e) { if (drag) mv(e.clientX); });
      ['pointerup', 'pointercancel'].forEach(function (n) { f.addEventListener(n, function () { drag = false; }); });
      if (knob) knob.addEventListener('keydown', function (e) { if (e.key === 'ArrowLeft') { set(pos - 5); e.preventDefault(); } if (e.key === 'ArrowRight') { set(pos + 5); e.preventDefault(); } });
    });
  }

  /* ---------- Opinie z Judge.me (publiczne endpointy) ---------- */
  var STAR = '<svg viewBox="0 0 24 24"><path d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z"/></svg>';
  function stars(n, cls) { var h = ''; for (var i = 1; i <= 5; i++) h += i <= Math.round(n) ? STAR : STAR.replace('<svg', '<svg class="off"'); return '<span class="x-stars ' + (cls || '') + '" aria-label="Ocena ' + n + ' na 5">' + h + '</span>'; }
  window.BWStars = stars;
  function ago(d) {
    var t = Math.floor((Date.now() - new Date(String(d).replace(' UTC', 'Z').replace(' ', 'T')).getTime()) / 864e5);
    if (isNaN(t)) return ''; if (t <= 0) return 'dzisiaj'; if (t === 1) return 'wczoraj'; if (t < 30) return t + ' dni temu';
    var m = Math.floor(t / 30); if (m < 12) return m === 1 ? 'miesiąc temu' : m + ' mies. temu'; var y = Math.floor(t / 365); return y === 1 ? 'rok temu' : y + ' lata temu';
  }
  function initReviews() {
    $$('[data-x-reviews]').forEach(function (root) {
      var list = $('[data-list]', root), more = $('[data-more]', root), shop = root.dataset.shop, pid = root.dataset.pid;
      var per = 24, FIRST = +(root.dataset.first || 4), STEP = 6, page = 0, pages = 1, total = 0, all = [], shown = FIRST, started = false, busy = false;
      var q = 'url=' + shop + '&shop_domain=' + shop + '&platform=shopify&per_page=' + per;
      var txt = function (h) { var d = document.createElement('div'); d.innerHTML = h || ''; return (d.textContent || '').trim(); };
      var score = function (r) { return (r.pics.length ? 1000 : 0) + Math.min(r.body.length, 400) + (r.rating >= 4 ? 200 : 0); };
      function fetchPage() {
        page++;
        if (pid) return fetch('https://judge.me/reviews/reviews_for_widget?' + q + '&page=' + page + '&product_id=' + pid).then(function (r) { return r.json(); }).then(function (d) {
          total = d.number_of_reviews || 0; pages = (d.pagination && d.pagination.total_pages) || 1;
          summary(parseFloat(d.average_rating) || 0, total, d.histogram);
          return (d.reviews || []).map(function (r) { return { rating: r.rating, title: r.title, body: txt(r.body_html), name: r.reviewer_name, date: r.created_at, ver: r.verified_buyer, prod: '', pics: (r.pictures_urls || []).map(function (p) { return p.compact || p.small || p.original; }).filter(Boolean) }; });
        });
        return fetch('https://judge.me/reviews/all_reviews_js_based?' + q + '&page=' + page).then(function (r) { return r.json(); }).then(function (d) {
          total = d.number_of_product_reviews || d.number_of_shop_reviews || 0; pages = Math.max(1, Math.ceil(total / per));
          var tEl = $('[data-total]', root); if (tEl && total) tEl.textContent = total;
          var doc = new DOMParser().parseFromString(d.html || '', 'text/html');
          return $$('.jdgm-rev', doc).map(function (el) {
            var g = function (s) { var x = $(s, el); return x ? x.textContent.trim() : ''; };
            var sc = $('[data-score]', el), ts = $('.jdgm-rev__timestamp', el);
            return { rating: sc ? +sc.getAttribute('data-score') : 5, title: g('.jdgm-rev__title'), body: g('.jdgm-rev__body'), name: g('.jdgm-rev__author'), date: ts ? ts.getAttribute('data-content') : '', ver: el.getAttribute('data-verified-buyer') === 'true', prod: g('.jdgm-rev__prod-link'), pics: $$('.jdgm-rev__pics img, img.jdgm-rev__pic-img', el).map(function (i) { return i.getAttribute('data-src') || i.getAttribute('src'); }).filter(Boolean) };
          });
        });
      }
      function summary(avg, tot, hist) {
        var a = $('[data-avg]', root); if (a && avg) a.textContent = avg.toFixed(2).replace('.', ',');
        var s = $('[data-avg-stars]', root); if (s && avg) s.innerHTML = stars(avg);
        var t = $('[data-total]', root); if (t && tot) t.textContent = tot;
        var h = $('[data-hist]', root);
        if (h && hist && hist.length) h.innerHTML = hist.slice().sort(function (x, y) { return y.rating - x.rating; }).map(function (r) {
          return '<div class="x-hist__row"><span>' + r.rating + '★</span><span class="x-hist__bar"><i style="width:' + r.percentage + '%"></i></span><span>' + r.frequency + '</span></div>';
        }).join('');
      }
      function card(r) {
        return '<article class="x-revcard"><div class="x-revcard__top">' + stars(r.rating, 'x-stars--sm') +
          (r.ver ? '<span class="x-revcard__ver"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M20 6 9 17l-5-5"/></svg>Zweryfikowany zakup</span>' : '') + '</div>' +
          (r.title ? '<h4>' + esc(r.title) + '</h4>' : '') + '<p>„' + esc(r.body) + '”</p>' +
          (r.pics.length ? '<div class="x-revcard__pics">' + r.pics.slice(0, 3).map(function (u) { return '<img src="' + esc(u) + '" alt="Zdjęcie od klienta" loading="lazy">'; }).join('') + '</div>' : '') +
          (r.prod ? '<span class="x-revcard__prod">' + esc(r.prod) + '</span>' : '') +
          '<div class="x-revcard__meta"><b>' + esc(r.name && r.name !== 'Anonymous' ? r.name : 'Klient BrightWhite') + '</b><span>' + ago(r.date) + '</span></div></article>';
      }
      function render() {
        list.innerHTML = all.slice(0, shown).map(card).join('') || '<p style="color:var(--muted)">Jeszcze nie ma opinii o tym produkcie.</p>';
        var can = shown < all.length || page < pages;
        more.hidden = !can && shown <= FIRST;
        more.innerHTML = can ? 'Pokaż więcej opinii (' + Math.max(0, total - Math.min(shown, all.length)) + ')' : 'Pokaż mniej';
      }
      more.addEventListener('click', function () {
        if (busy || !started) return;
        var can = shown < all.length || page < pages;
        if (!can) { shown = FIRST; render(); root.scrollIntoView({ behavior: 'smooth' }); return; }
        shown += STEP;
        if (shown > all.length && page < pages) { busy = true; more.innerHTML = SPIN; fetchPage().then(function (m) { all = all.concat(m.sort(function (a, b) { return score(b) - score(a); })); }).finally(function () { busy = false; render(); }); }
        else render();
      });
      function start() { if (started) return; started = true; fetchPage().then(function (r) { all = r.sort(function (a, b) { return score(b) - score(a); }); render(); }).catch(function () { list.innerHTML = '<p style="color:var(--muted)">Nie udało się wczytać opinii.</p>'; }); }
      if ('IntersectionObserver' in window) { var io = new IntersectionObserver(function (e) { if (e[0].isIntersecting) { io.disconnect(); start(); } }, { rootMargin: '800px' }); io.observe(root); }
      setTimeout(start, 3500);
    });
  }

  /* ---------- Animacje wejścia ---------- */
  function initReveal() {
    var els = $$('.x-reveal'); if (!els.length) return;
    if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (en) { en.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } }); }, { rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (e) { io.observe(e); });
    setTimeout(function () { els.forEach(function (e) { e.classList.add('is-in'); }); }, 2500);
  }

  function init() { initHeader(); initSearch(); initCart(); initAcc(); initBA(); initReviews(); initReveal(); document.dispatchEvent(new CustomEvent('bw:ready')); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
